<template>
  <div class="divBG">
    <div class="divMsg">
      <div>
        <br>
        <br>
        <table class="tbList">
          <tr>
            <td class="alinR w42pc">原密码：</td><td><input v-model="pwd1" class="ipt01" type="password" @focus="toPwd"></td>
          </tr>
          <tr>
            <td class="alinR w42pc">新密码：</td><td><input v-model="pwd2" class="ipt01" type="password" @focus="toPwd"></td>
          </tr>
          <tr>
            <td class="alinR w42pc">确认新密码：</td><td><input v-model="pwd3" class="ipt01" type="password" @focus="toPwd"></td>
          </tr>
        </table>
        <div class="divMsg1">
          <b style="color:red;">{{ errMsg }}</b>
        </div>
      </div>
      <div class="divMsg2">
        <p class="divMsgP divMsgP1" @click="f1_action(false)">取消</p>
        <p class="divMsgP divMsgP2" @click="save">确定</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import './../../../static/c_table.css'
export default{
  name: 'PwdBox',
  props: {
    f1_action: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      errMsg: '',
      pwd1: '',
      pwd2: '',
      pwd3: ''
    }
  },
  methods: {
    save() {
      if (this.pwd1 === '') {
        this.errMsg = '请填写原密码'
        return
      }
      if (this.pwd2 === '' || this.pwd3 === '') {
        this.errMsg = '请填写新密码'
        return
      }
      if (this.pwd2 !== this.pwd3) {
        this.errMsg = '两次新密码不同'
        return
      }
      this.f1_action(this.pwd1, this.pwd2)
    },
    toPwd() {
      this.errMsg = ''
    }
  }
}
</script>
<style>/**scoped */
.divMsg{
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0;
  margin: 5% 25%;
  color:darkslategrey;
  background-color: white;
  border-radius: 3px;
  text-align: center;
  z-index: 45;
}
.divMsg1{
  font-size: 15px;
  padding: 20px 0;
}
.divMsg2{
  width: 100%;
  display: block;
  display: flex;
  flex-direction: row;
}
.divMsgP{
  width: 50%;
  height: 20px;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}
.divMsgP1{
  /**background-color: rgb(230, 227, 227); */
  border-bottom-left-radius: 3px;
}
.divMsgP2{
  /**background-color: rgb(105, 168, 105); */
  background-color: rgba(14, 14, 155, 0.726);
  color: white;
  border-bottom-right-radius: 3px;
}

.ipt01{
  width: 260px;
  height: 20px;
  margin: 5px 0;
  font-size: 16px;
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/comps/c3_tools/04_pwd.vue